<template>
  <div class="app-side fs">
    <component v-if="sideComponent" :is="sideComponent" />
  </div>
</template>

<script setup lang="ts">
import { useCurrentAppInstance, RUNTIME_GLOBAL_EVENTS, computed, onMounted, reactive, ref, watch } from '@zto/zpage'

const app = useCurrentAppInstance()

const sideConfig = app.useAppConfig('side', {})

const sideComponent = sideConfig.comonent || app.resolveComponent('CAppSidePanel')
</script>

<style lang="scss" scoped>
.app-side {
  overflow: hidden;
}
</style>
